import timIm from './newim'
import yunxinim from './yunxinim'

export default {
  loginIM,
  logout,
  loginYunXinChatRoom,
  sendApplyLink,
  sendSureLink,
  sendRefuseLink,
  sendCannotLink,
  sendTextMsg,
  onSendP2PMsg,
  studentOneKeyLinkMic
}

// var memberMsgListener
// function setMemberMsgListener (cb) {
//   memberMsgListener = cb
// }

// var imStatusListener
// function setImStatusListener (cb) {
//   imStatusListener = cb
// }

// var normalCallBack // 普通消息回调，在互动页面显示的消息为普通消息
// function setMsgListener (cb) {
//   normalCallBack = cb
// }
let currIMType = 0  // 1 腾讯  2 网易
let loginInfo = {}
// 配置IM
function loginIM (data, imType, callBackObj) {
  // currentGroupId = data.room_id
  // loginInfo.identifier = data.fans_id
  // loginInfo.identifierNick = data.nick
  // loginInfo.headurl = data.header
  // loginInfo.userSig = data.tsl_sig
  loginInfo =  data;
  currIMType = imType
  if (imType === 1) { // 腾讯IM
    timIm.configIM(data)
    timIm.logout(function () {
      timIm.loginAndJoinGroup(function (isOK) {
        if (isOK) {
          console.log('加入直播间成功1204')
          // 发送消息
          timIm.setMsgListener((msgdata) => { // 群聊消息
            callBackObj && callBackObj.setMsgListener && callBackObj.setMsgListener(msgdata)
          })
          timIm.setImStatusListener((msgdata) => { // im状态
            callBackObj && callBackObj.setImStatusListener && callBackObj.setImStatusListener(msgdata)
          })
          timIm.setMemberMsgListener(msgdata => { // 私聊消息
            callBackObj && callBackObj.setMemberMsgListener && callBackObj.setMemberMsgListener(msgdata)
          })
        }
      })
    })
  } else if (imType === 2) { // 网易IM
    // appKey: data.appKey,
    // account: data.fans_id,
    // token: data.token,
    // chatroomId: data.chatroomId,
    // chatroomAddresses: data.address,
    // quickReconnect: true,
    // tags: data.tags,
    yunxinim.setMsgListener((msgdata,element) => { // 群聊消息
      callBackObj && callBackObj.setMsgListener && callBackObj.setMsgListener(msgdata,element)
    })
    yunxinim.setImStatusListener((msgdata) => { // im状态
      callBackObj && callBackObj.setImStatusListener && callBackObj.setImStatusListener(msgdata)
    })
    yunxinim.setMemberMsgListener(msgdata => { // 私聊消息
      callBackObj && callBackObj.setMemberMsgListener && callBackObj.setMemberMsgListener(msgdata)
    })
    yunxinim.loginIM(data)
  }
}

function loginYunXinChatRoom (data, callBackObj) {
  yunxinim.setImStatusListener((msgdata) => { // im状态
    callBackObj && callBackObj.setImStatusListener && callBackObj.setImStatusListener(msgdata)
  })
  yunxinim.loginYunXinChatRoom(data)
}

// 申请连麦
function sendApplyLink () {
  var date1 = new Date()
  var timestamp = Date.parse(date1)
  var time = date1.pattern('MM-dd hh:mm')
  var obj = {}
  obj.nick = loginInfo.identifierNick
  obj.header_url = loginInfo.headurl
  obj.fans_id = loginInfo.identifier
  obj.time = time
  obj.msgid = timestamp
  obj.module = 'applyLink'

  // var text = JSON.stringify(obj)
  onSendMsg(obj)
}

// 接收老师邀请，确认上麦
function sendSureLink () {
  var date1 = new Date()
  var timestamp = Date.parse(date1)
  var time = date1.pattern('MM-dd hh:mm')
  var obj = {}
  obj.nick = loginInfo.identifierNick
  obj.header_url = loginInfo.headurl
  obj.fans_id = loginInfo.identifier
  obj.time = time
  obj.msgid = timestamp
  obj.module = 'sureLink'
  // var text = JSON.stringify(obj)
  onSendMsg(obj)
}

// 学生一键连麦
function studentOneKeyLinkMic () {
  var date1 = new Date()
  var timestamp = Date.parse(date1)
  var time = date1.pattern('MM-dd hh:mm')
  var obj = {}
  obj.nick = loginInfo.identifierNick
  obj.header_url = loginInfo.headurl
  obj.fans_id = loginInfo.identifier
  obj.time = time
  obj.msgid = timestamp
  obj.student_onekey_linkMic = 1
  obj.module = 'applyLink'
  // var text = JSON.stringify(obj)
  onSendMsg(obj)
}

// 接收老师邀请，拒绝上麦
function sendRefuseLink () {
  var date1 = new Date()
  var timestamp = Date.parse(date1)
  var time = date1.pattern('MM-dd hh:mm')
  var obj = {}
  obj.nick = loginInfo.identifierNick
  obj.header_url = loginInfo.headurl
  obj.fans_id = loginInfo.identifier
  obj.time = time
  obj.msgid = timestamp
  obj.module = 'refuseLink'
  // var text = JSON.stringify(obj)
  onSendMsg(obj)
}

function sendTextMsg (msg) {
  // var text = JSON.stringify(msg)
  onSendMsg(msg)
}

// 当前设备不支持连麦
function sendCannotLink (content) {
  var date1 = new Date()
  var timestamp = Date.parse(date1)
  var time = date1.pattern('MM-dd hh:mm')
  var obj = {}
  obj.nick = loginInfo.identifierNick
  obj.header_url = loginInfo.headurl
  obj.fans_id = loginInfo.identifier
  obj.time = time
  obj.msgid = timestamp
  obj.module = 'cannotLink'
  obj.content = content
  // var text = JSON.stringify(obj)
  onSendMsg(obj)
}
// eslint-disable-next-line no-extend-native
Date.prototype.pattern = function (fmt) {
  var o = {
    'M+': this.getMonth() + 1, // 月份
    'd+': this.getDate(), // 日
    'h+': this.getHours() % 12 === 0 ? 12 : this.getHours() % 12, // 小时
    'H+': this.getHours(), // 小时
    'm+': this.getMinutes(), // 分
    's+': this.getSeconds(), // 秒
    'q+': Math.floor((this.getMonth() + 3) / 3), // 季度
    S: this.getMilliseconds() // 毫秒
  }
  var week = {
    '0': '/u65e5',
    '1': '/u4e00',
    '2': '/u4e8c',
    '3': '/u4e09',
    '4': '/u56db',
    '5': '/u4e94',
    '6': '/u516d'
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      (this.getFullYear() + '').substr(4 - RegExp.$1.length)
    )
  }
  if (/(E+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      (RegExp.$1.length > 1
        ? RegExp.$1.length > 2
          ? '/u661f/u671f'
          : '/u5468'
        : '') + week[this.getDay() + '']
    )
  }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length)
      )
    }
  }
  return fmt
}

// 发送IM消息
function onSendMsg (text) {
  if (currIMType === 2) { // 云信
    yunxinim.sendTextMsg(text)
  }else { // 腾讯
    timIm.sendTextMsg(text)
  } 
}

// eslint-disable-next-line camelcase
function onSendP2PMsg (text, fans_id) {
   if (currIMType === 2) { // 云信
    yunxinim.onSendP2PMsg(text, fans_id)
  }else { // 腾讯
    timIm.onSendP2PMsg(text, fans_id)
  }
}

function logout(params) {
    if (currIMType == 2) {
        yunxinim.logout()
    }else {
        timIm.logout(()=>{})
    }
}



// WEBPACK FOOTER //
// ./src/kits/im/handleim.js